// Environment configuration helper
// This allows environment variables to be injected at runtime in production

const getEnvConfig = () => {
    // In production, use runtime config from window.ENV
    // In development, use process.env
    if (process.env.NODE_ENV === 'production' && window.ENV) {
        return {
            API_URL: window.ENV.REACT_APP_API_URL || '',
            SOCKET_URL: window.ENV.REACT_APP_SOCKET_URL || '',
            LINEAR_CLIENT_ID: window.ENV.REACT_APP_LINEAR_CLIENT_ID || '',
            PADDLE_VENDOR_ID: window.ENV.REACT_APP_PADDLE_VENDOR_ID || '',
            PADDLE_PUBLIC_KEY: window.ENV.REACT_APP_PADDLE_PUBLIC_KEY || '',
            GITHUB_CLIENT_ID: window.ENV.REACT_APP_GITHUB_CLIENT_ID || '',
            SLACK_CLIENT_ID: window.ENV.REACT_APP_SLACK_CLIENT_ID || '',
            ENABLE_SLACK: window.ENV.REACT_APP_ENABLE_SLACK === 'true',
            ENABLE_GITHUB: window.ENV.REACT_APP_ENABLE_GITHUB === 'true',
            AUTH_MODE: window.ENV.REACT_APP_AUTH_MODE || 'local',
            PADDLE_ENVIRONMENT: window.ENV.REACT_APP_PADDLE_ENVIRONMENT || 'sandbox',
            POSTHOG_API_KEY: window.ENV.REACT_APP_POSTHOG_API_KEY,
            POSTHOG_HOST: window.ENV.REACT_APP_POSTHOG_HOST,
            IS_DEV: window.ENV.NODE_ENV === 'development',
            // Add any other env vars you need
            ...window.ENV
        };
    }

    // Development fallback
    return {
        API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
        SOCKET_URL: process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000',
        LINEAR_CLIENT_ID: process.env.REACT_APP_LINEAR_CLIENT_ID || '',
        JIRA_CLIENT_ID: process.env.REACT_APP_JIRA_CLIENT_ID || '',
        PADDLE_VENDOR_ID: process.env.REACT_APP_PADDLE_VENDOR_ID || '',
        PADDLE_PUBLIC_KEY: process.env.REACT_APP_PADDLE_PUBLIC_KEY || '',
        GITHUB_CLIENT_ID: process.env.REACT_APP_GITHUB_CLIENT_ID || '',
        SLACK_CLIENT_ID: process.env.REACT_APP_SLACK_CLIENT_ID || '',
        ENABLE_SLACK: process.env.REACT_APP_ENABLE_SLACK === 'true',
        ENABLE_GITHUB: process.env.REACT_APP_ENABLE_GITHUB === 'true',
        AUTH_MODE: process.env.REACT_APP_AUTH_MODE || 'local',
        PADDLE_ENVIRONMENT: process.env.REACT_APP_PADDLE_ENVIRONMENT || 'sandbox',
        POSTHOG_API_KEY: process.env.REACT_APP_POSTHOG_API_KEY,
        POSTHOG_HOST: process.env.REACT_APP_POSTHOG_HOST,
        IS_DEV: process.env.NODE_ENV === 'development',
        // Spread all REACT_APP_* env vars
        ...Object.keys(process.env)
            .filter(key => key.startsWith('REACT_APP_'))
            .reduce((acc, key) => ({ ...acc, [key]: process.env[key] }), {})
    };
};

export const config = getEnvConfig();
